import { render, staticRenderFns } from "./SaveDocuments.vue?vue&type=template&id=4fdab486&scoped=true"
import script from "./SaveDocuments.vue?vue&type=script&lang=js"
export * from "./SaveDocuments.vue?vue&type=script&lang=js"
import style0 from "./SaveDocuments.vue?vue&type=style&index=0&id=4fdab486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdab486",
  null
  
)

export default component.exports